import React, { useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import ExploreOffIcon from '@mui/icons-material/ExploreOff';
import { tokens } from '../onboarding';

/**
 * Route catch-all. Avant ce composant, App.tsx ne déclarait aucun `path="*"` :
 * les 20 destinations visées par VisasScreen mais jamais déclarées produisaient
 * une page entièrement blanche, sans message ni sortie.
 *
 * On affiche un message explicite plutôt qu'une redirection silencieuse : la liste
 * des URL demandées est une information commerciale directe sur les destinations à ouvrir.
 * La journalisation serveur arrive avec le backend du lot 2 ; ici on trace en console.
 */
const PageIntrouvable: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.warn('[VisaMonde] Route introuvable :', location.pathname);
  }, [location.pathname]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        p: 3,
        backgroundColor: '#f8f9fa',
      }}
    >
      <Box
        sx={{
          width: 88,
          height: 88,
          borderRadius: '50%',
          backgroundColor: '#e8f5e9',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
        }}
      >
        <ExploreOffIcon sx={{ fontSize: 44, color: tokens.VERT }} />
      </Box>

      <Typography variant="h5" sx={{ fontWeight: 700, color: '#333', mb: 1.5 }}>
        Cette page n'existe pas
      </Typography>
      <Typography variant="body1" sx={{ color: '#666', maxWidth: 420, lineHeight: 1.6, mb: 3 }}>
        Le lien que vous avez suivi ne correspond à aucune page de l'application. Si vous
        cherchiez une destination précise, écrivez-nous&nbsp;: nous pouvons monter votre
        dossier manuellement.
      </Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, justifyContent: 'center' }}>
        <Button
          variant="contained"
          onClick={() => navigate('/retour', { replace: true })}
          sx={{
            py: 1.25,
            px: 3,
            borderRadius: tokens.RAYON,
            textTransform: 'none',
            fontWeight: 600,
            background: tokens.GRADIENT_VERT,
            boxShadow: tokens.OMBRE_BOUTON,
            '&:hover': { background: tokens.GRADIENT_VERT_HOVER, boxShadow: tokens.OMBRE_BOUTON_HOVER },
          }}
        >
          Retour aux destinations
        </Button>
        <Button
          variant="text"
          href="mailto:contact@visamonde.com"
          sx={{ textTransform: 'none', color: '#666', fontWeight: 500 }}
        >
          Contacter un conseiller
        </Button>
      </Box>
    </Box>
  );
};

export default PageIntrouvable;
